// @flow
import React from 'react';
import PlatformIcon, { UNDEFINED_PLATFORM } from './PlatformIcon';
import PopOver from './PopOver';
import './stylesheets/AppGroupHeader.scss';
import type { App } from '../constants/RailsApiTypes';

type Props = {
  appGroupName: string,
  apps: Array<App>
};

const AppName = (props: { name: string }) => <div>{props.name}</div>;

const AppAndPlatform = (props: { name: string, platform: string }) => (
  <div className="AppAndPlatform__App">
    <span className="AppAndPlatform__App__Name">{props.name}</span>
    <div className="AppAndPlatform__App__Platform">
      <PlatformIcon platform={props.platform || UNDEFINED_PLATFORM} />
    </div>
  </div>
);

const PlatformDetails = (props: {
  appNames: Array<string>,
  platform: string
}) => (
  <PopOver
    preferPlace="below"
    content={
      <div className="AppGroupHeader__PopOverContent AppGroupHeader__PopOverContent__Platform">
        {props.appNames.map(name => <AppName key={name} name={name} />)}
      </div>
    }
  >
    <PlatformIcon platform={props.platform} />
  </PopOver>
);

const AppGroupHeader = (props: Props) => {
  const { apps, appGroupName } = props;
  const platformProps = apps.reduce((acc, val) => {
    if (val) {
      const { integration_platform: platform } = val;
      if (acc[platform]) {
        acc[platform] = [...acc[platform], val.name];
      } else {
        acc[platform || UNDEFINED_PLATFORM] = [val.name];
      }
    }
    return acc;
  }, {});

  return (
    <div className="AppGroupHeader">
      <PopOver
        preferPlace="below"
        content={
          <div className="AppGroupHeader__PopOverContent AppGroupHeader__PopOverContent__Name">
            {apps
              .filter(app => !!app)
              .map(app => (
                <AppAndPlatform
                  key={app.name + app.integration_platform}
                  name={app.name}
                  platform={app.integration_platform}
                />
              ))}
          </div>
        }
      >
        <div className="AppGroupHeader__AppGroup">
          <span className="AppGroupHeader__AppGroup__Details">
            App Group ({`${apps && apps.length} App${
              apps && apps.length > 1 ? 's' : ''
            }`})
          </span>
          <span className="AppGroupHeader__AppGroup__Name">{appGroupName}</span>
        </div>
      </PopOver>
      <div className="AppGroupHeader__Spacer" />

      <div className="AppGroupHeader__AppGroup__Icons">
        {Object.keys(platformProps).map(plat => (
          <PlatformDetails
            key={plat}
            platform={plat}
            appNames={platformProps[plat]}
          />
        ))}
      </div>
    </div>
  );
};

AppGroupHeader.defaultProps = {};

export default AppGroupHeader;



// WEBPACK FOOTER //
// ./src/components/AppGroupHeader.jsx